import { sinIvaFromPriceIva } from './printDocumentIva'

export function buildFacturaPrintParams(facturaRow, priceWithIva) {
  if (!facturaRow) return null

  const orderIds = Array.isArray(facturaRow.orders)
    ? facturaRow.orders.join(',')
    : facturaRow.orders

  const dateVal = facturaRow.fetcha
    ? new Date(facturaRow.fetcha).toISOString()
    : facturaRow.date

  return {
    orderIds,
    number: facturaRow.number,
    numberInYear: facturaRow.numberInYear,
    date: dateVal,
    accountKey: facturaRow.accountKey || 'ADM',
    sinIva: sinIvaFromPriceIva(priceWithIva),
  }
}

export function buildAlbaranPrintParams(orderId, tradeName, priceWithIva) {
  if (!orderId) return null
  return {
    id: orderId,
    tradeName,
    sinIva: sinIvaFromPriceIva(priceWithIva),
  }
}
